import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StudentSessionsCheckoutService } from 'src/app/services/http/business/StudentSessionsCheckout/student-sessions-checkout.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
// import { IConfirm } from 'src/app/interfaces/confirm';
// import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';

@Component({
  selector: 'app-register-mark',
  templateUrl: './register-mark.component.html',
  styleUrls: ['./register-mark.component.css']
})
export class RegisterMarkComponent implements OnInit {
  form: FormGroup;
  educationPackageId: any;
  isFinal: boolean = false;
  isUpdate: boolean = false;
  MarkTypes: any = [];
  markClassificationTypes: any = [];
  showFinal: boolean;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    // "attendance",
    "MarkType",
    "Mark",
    "MarkClassification",
    "Coefficient",
    "function"
  ];
  studentMarks: any = [];

  constructor(
    private fb: FormBuilder,
    private studentSessionsCheckoutService: StudentSessionsCheckoutService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    // private dialog: MatDialog,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<RegisterMarkComponent>,
    @Inject(MAT_DIALOG_DATA) public dataParams: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.refresh();
    this.getEducationPackageId();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [0],
      Mark: [0, this.isUpdate || this.isFinal ? 0 : Validators.required],
      MarkTypeId: [this.isUpdate || this.isFinal ? null : Validators.required],
      MarkClassificationId: [this.isFinal ? Validators.required : null],
      isFinal: [false],
    });
  }


  getEducationPackageId() {

    let queryParams = {
      CourseId: this.dataParams.CourseId,
      AllSessionId: this.dataParams.AllSessionId
    }
    this.studentSessionsCheckoutService.getEducationPackageId(queryParams).subscribe(
      res => {

        this.educationPackageId = res.PackageId;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  };

  getMarkClassificationList(params: any) {
    let command = {
      Id: params
    }
    this.studentSessionsCheckoutService.getMarkClassificationList(command).subscribe(
      res => {
        this.markClassificationTypes = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  };

  loadMarkClassification(isFinal: boolean) {
    if (isFinal) {
      this.getMarkClassificationList(this.educationPackageId);
      this.form.controls['MarkTypeId'].patchValue(null);
      this.form.controls['Mark'].patchValue(0);
    }
    else {
      this.isFinal = false;
      this.form.controls['MarkClassificationId'].patchValue(0);
      // this.form.setValue({
      //   MarkClassificationId: 0,
      // });
    }
    // isFinal ?
    //   this.getMarkClassificationList(this.educationPackageId)
    //   :
    //   this.form.setValue({
    //     MarkClassificationId: 0,
    //   });
  }

  refresh() {
    let command = {
      CourseId: this.dataParams.CourseId,
      AllSessionId: this.dataParams.AllSessionId,
      RegistrationId: this.dataParams.RegistrationId
    };
    this.studentSessionsCheckoutService.getMarkStudentList(command).subscribe(res => {

      this.dataSource = res.StudentMarks[0].StudentMarks;
      this.studentMarks = res.StudentMarks[0].StudentMarks;
      this.showFinal = res.StudentMarks[0].StudentMarks.some(function (e) {
        return (e.TypeId > 0 && e.Mark != null)
      });
      this.MarkTypes = res.Headers;
      this.MarkTypes.forEach(item => {
        if (item.TypeId <= 0) {
          this.MarkTypes.splice(this.MarkTypes.indexOf(item), 1)
        }
      });
    }, () => { })
  }

  submit(form: any) {

    // let confirm: IConfirm = {
    //   accept: true,
    //   message: 'کاربر گرامی توجه داشته باشید در صورت ثبت نمره مردودی برای دانشجو، وضعیت ثبت نام ترم جدید به حالت معلق تغییر خواهد کرد.',
    //   alert: null,
    //   yesLabel: this.translate.get("label.yes"),
    //   noLabel: this.translate.get("label.no")
    // };

    // const dialogRef = this.dialog.open(ConfirmComponent, {
    //   width: "450px",
    //   data: confirm
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    if (this.isFinal) {
      let temp = this.studentMarks.find(x => x.TypeId == 0);
      form.Id = temp.Id
      form.MarkTypeId = temp.TypeId
    } else if (!this.isUpdate) {
      form.Id = this.studentMarks.find(x => x.TypeId == form.MarkTypeId).Id;
    }

    let command: any = {
      "CourseId": this.dataParams.CourseId,
      "CalculationMethodName": null,
      "StudentsMarks": [
        {
          "RegistrationId": this.dataParams.RegistrationId,
          "StudentFullName": this.dataParams.StudentFullName,
          "NationalCode": this.dataParams.NationalCode,
          "StudentMarks": [
            {
              "Id": form.Id,
              "TypeId": form.MarkTypeId,
              "MarkClassificationId": form.MarkClassificationId,
              "Coefficient": form.Coefficient,
              "Mark": form.Mark,//this.isUpdate?form.Mark:0,
              "MarkClassificationName": null,
              "IsActive": true,
              "IsFinal": true,
              "IsMain": true
            }
          ]
        }
      ]
    }
    this.studentSessionsCheckoutService.saveMarkStudent(command).subscribe(() => {

      this.isFinal = this.form.get('isFinal').value;
      this.snackBar.OpenSnackBar(
        'ثبت نمره با موفقیت انجام شد',
        "ok",
        3000,
        SoundEnum.beep
      );
      //this.finalResult=res;
      this.createForm();
      this.refresh();
      this.isFinal = false;
      this.isUpdate = false;
    },
      () => { });
    //   }
    // });
  }
  //update mark
  edit(items: any) {

    this.isUpdate = false;
    this.createForm();
    this.form.setValue({
      Id: items.Id,
      Mark: items.Mark,
      MarkTypeId: items.TypeId,
      MarkClassificationId: items.MarkClassificationId,
      isFinal: items.MarkClassificationId ? true : false
    });
    this.isFinal = false;// this.form.get('isFinal').value;
  }
  onNoClick() {
    this.dialogRef.close();
  }

}
